import { type VoucherItem } from '@/types'
import type { Dispatch, FC, PropsWithChildren, SetStateAction } from 'react'
import { createContext, useContext, useState } from 'react'

interface ProductContextProps {
  setIsVoucherLoginOpen: Dispatch<SetStateAction<boolean>>
  setVoucherChoose: Dispatch<SetStateAction<VoucherItem | undefined>>
  voucherChoose: VoucherItem | undefined
  isVoucherLoginOpen: boolean
}

export const ProductContext = createContext<ProductContextProps>(
  {} as ProductContextProps
)

export const ProductContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [voucherChoose, setVoucherChoose] = useState<VoucherItem>()
  const [isVoucherLoginOpen, setIsVoucherLoginOpen] = useState<boolean>(false)

  return (
    <ProductContext.Provider
      value={{
        setVoucherChoose,
        voucherChoose,
        isVoucherLoginOpen,
        setIsVoucherLoginOpen,
      }}
    >
      {children}
    </ProductContext.Provider>
  )
}

export const useProductContext = () => useContext(ProductContext)
